import CloseIcon from "@mui/icons-material/Close";
import {
  Grid
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { skyBlueNew } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  checkedListEmptyMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg
} from "../../config/messageconstant";
import { getStockholderByUserArea } from "../../Slice/StackHolder.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const moduleRoute = '/multiple-product-rate-structure';
const REDIRECT_DELAY_MS = 3000;

const MultipleStructurePopUp = ({
  handleClose,
  open,
  showNotification,
  showLoador,
  rows,
  productRateStructureList,
  getStockholderByUserArea,
  stakeholdersList,
}) => {
  const [rowData, setRowData] = React.useState([]);
  const [allChecked, setAllChecked] = React.useState(false);
  const [popUpOpenFlag, setPopUpOpenFlag] = React.useState(false);
  const [publishDate, setPublishDate] = React.useState("");
  const [formErrors, setFormErrors] = React.useState({});
  const [
    searchValueForProductRateStructure,
    setSearchValueForProductRateStructure,
  ] = React.useState("");
  const [isLog, setIsLog] = React.useState(true);
  const [moduleObjDataObj, setModuleObjDataObj] = React.useState({});

  React.useEffect(() => {
    const moduleObjData = localStorage.getItem("moduleObj");
    const moduleObjDataObj =
      moduleObjData != null ? JSON.parse(moduleObjData) : {};

    setModuleObjDataObj(moduleObjDataObj);

    fetchProductRateStructure();
  }, []);

  const fetchProductRateStructure = async () => {
    showLoador({ loador: true });
    await getStockholderByUserArea().then(({ response, success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      } else {
        setRowData(response);
      }
    });

    setPopUpOpenFlag(true);
  };

  const handleCloses = () => {
    handleClose();
  };

  const onDateChange = (name) => (date) => {
    if (name === "publishDate") {
      setPublishDate(date);
    }
  };

  const handleAllCheckedClick = (event) => {
    const { checked } = event.target;
    setAllChecked(checked);

    const updatedData = rowData.map((publishObject) => ({
      ...publishObject,
      isChecked: checked,
    }));

    setRowData(updatedData);
  };

  const handleClick = (e, id) => {
    const updatedData = rowData.map((publishObject) =>
      publishObject.id === id
        ? { ...publishObject, isChecked: e.target.checked }
        : publishObject
    );
    setRowData(updatedData);
  };

  const onSearchProductRateStructure = (searchValueForProductRateStructure) => {
    setSearchValueForProductRateStructure(searchValueForProductRateStructure);
  };

  const getFilteredTableData = (searchData) => {
   
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(
              searchValueForProductRateStructure.trim().toLowerCase()
            )) ||
        (currentRow["userName"] &&
          currentRow["userName"]
            .toString()
            .toLowerCase()
            .includes(
              searchValueForProductRateStructure.trim().toLowerCase()
            )) ||
        (currentRow["stateName"] &&
          currentRow["stateName"]
            .toString()
            .toLowerCase()
            .includes(
              searchValueForProductRateStructure.trim().toLowerCase()
            )) ||
        (currentRow["brandName"] &&
          currentRow["brandName"]
            .toString()
            .toLowerCase()
            .includes(
              searchValueForProductRateStructure.trim().toLowerCase()
            )) ||
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProductRateStructure.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  const onSubmitHandler = async() => {

    const saveList = rowData
      .filter((row) => row.isChecked)
      .map((rowDataObj) => rowDataObj.id);

    let saveData = {
      stockStakeHolderIds: saveList,
      productMrpHolderWiseRates: rows.productMrpHolderWiseRates,
    };

    if (saveList.length !== 0) {
      swal({
				title: "Are you sure?",
				text: saveWarningMsg,
				icon: "warning",
				buttons: true,
				dangerMode: true,
			}).then(async (willDelete) => {
				if (willDelete) {
					showLoador({ loador: true });
					await apiPost({
						url:
							endpoint.productRateStructureAssignation +
							"/and-product-rate-structure-edit-optimize",
						postBody: saveData,
					}).then(({ data, success }) => {
						if (success && !data?.error) {
							showNotification({ msg: data?.data?.message ?? savemsg });
							setTimeout(() => {
								window.location.replace(moduleRoute);
							}, REDIRECT_DELAY_MS);
						} else {
							showNotification({
								msg: data?.errorMessage ?? saveFailedMsg,
								severity: "error",
							});
						}
					});
					showLoador({ loador: false });
				}
			});
    } else {
      showNotification({ msg: checkedListEmptyMsg, severity: "error" });
    }
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleCloses}
        aria-labelledby="customized-dialog-title"
        open={popUpOpenFlag}
        fullWidth
        maxWidth="lg"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloses}
        >
          Stock Holder List
        </BootstrapDialogTitle>

        <DialogContent dividers>
          <LandingScreenHeader
            screenTitle={""}
            showSearchBox={true}
            showTable={true}
            showFilter={false}
            showPdfDownload={false}
            showExcelDownload={false}
            onSearch={onSearchProductRateStructure}
          />

          <div style={{ maxHeight: 400, overflowY: "auto" }}>
            <table
              style={{
                minWidth: 650,
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #ccc",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#f1f1f1",
                  zIndex: 1,
                  background: skyBlueNew,
                  color: "white",
                  fontSize: "15px",
                  border: "1px solid #ccc",
                  height: '40px',
                }}
              >
                <tr>
                  <th
                    style={{
                      padding: "4px",
                      textAlign: "center",
                      fontSize: "15px",
                      border: "1px solid #ccc",
                      width: "50px",
                    }}
                  >
                    <input
                      type="checkbox"
                      color="error"
                      onClick={handleAllCheckedClick}
                      checked={allChecked}
                      aria-label="select all structures"
                      style={{
                        transform: "scale(1.4)",
                        height: '13px',
                        width: '13px',
                        cursor: "pointer",
                        accentColor: allChecked ? "red" : "skyblue",
                      }}
                    />
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      padding: "4px",
                      border: "1px solid #ccc",
                      width: "70px",
                    }}
                  >
                    Sr. No.
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      padding: "4px",
                      border: "1px solid #ccc",
                    }}
                  >
                    User Name
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      padding: "4px",
                      border: "1px solid #ccc",
                    }}
                  >
                    State
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      padding: "4px",
                      border: "1px solid #ccc",
                    }}
                  >
                    Brand
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      padding: "4px",
                      border: "1px solid #ccc",
                    }}
                  >
                    Stock Holder
                  </th>
                </tr>
              </thead>
              <tbody>
                {getFilteredTableData(rowData).map((row, index) => (
                  <tr key={row.id}>
                    <td
                      style={{
                        textAlign: "center",
                        padding: "4px",
                        border: "1px solid #ccc",
                      }}
                    >
                      <input
                        type="checkbox"
                        color="primary"
                        onClick={(event) => handleClick(event, row.id)}
                        checked={row.isChecked}
                        aria-labelledby={"enhanced-table-checkbox-" + index}
                        style={{
                          height: '13px',
                          width: '13px',
                          transform: "scale(1.3)", cursor: "pointer"
                        }}
                      />
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        padding: "4px",
                        fontSize: "14px",
                        border: "1px solid #ccc",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        padding: "4px",
                        fontSize: "14px",
                        border: "1px solid #ccc",
                      }}
                    >
                      {row.userName}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "4px",
                        fontSize: "14px",
                        border: "1px solid #ccc",
                      }}
                    >
                      {row.stateName}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "4px",
                        fontSize: "14px",
                        border: "1px solid #ccc",
                      }}
                    >
                      {row.brandName}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "4px",
                        fontSize: "14px",
                        border: "1px solid #ccc",
                      }}
                    >
                      {row.name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <br />

          <Grid
            container
            justifyContent="flex-end"
            spacing={2}
            alignItems="center"
          >
            {/* <Grid item>
                            <BasicDatePicker
                                color="primary"
                                name="publishDate"
                                size="small"
                                value={publishDate}
                                disabled={false}
                                onChange={onDateChange("publishDate")}
                                isError={
                                    formErrors["publishDateError"]
                                        ? formErrors["publishDateError"]
                                        : ""
                                }
                                errorText={
                                    formErrors["publishDateError"]
                                        ? formErrors["publishDateError"]
                                        : ""
                                }
                            />
                        </Grid>
                        &nbsp;&nbsp; */}
            <Grid item>
              <ButtonCompo
                size="medium"
                type="submit"
                variant="contained"
                name="Submit"
                onClick={onSubmitHandler}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  productRateStructureList: state.productRateStructure,
  stakeholdersList: state.stackholder,
});

const mapDispatchToProps = {
  getStockholderByUserArea,
  showNotification,
  showLoador,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultipleStructurePopUp);
